// src/oura/components/client/ScreenSentence.tsx
//
// The page sentence on the two staff screens of this area (Client, and Search
// performance), in whichever business chrome is running.

import type { ReactNode } from "react";
import { isBusinessSidebarLive } from "../../nav";
import { cn } from "../../lib/cn";
import { PageSentence, TYPE } from "@oura/ui";

/**
 * The one sentence under the page title.
 *
 * The sidebar chrome owns the header and takes the sentence through its slot.
 * The sidebar flag (`isBusinessSidebarLive`) is on in every environment,
 * production included. It still exists, and with it off the legacy tab strip
 * runs: it titles the page with the business name and has no header, so the
 * screen names itself here. `PageSentence` on its own would render the
 * sentence in place there too, but without this screen's name.
 */
export function ScreenSentence({ title, children }: { title?: string; children: ReactNode }) {
    if (isBusinessSidebarLive) return <PageSentence>{children}</PageSentence>;
    return (
        <div className="mb-5">
            {title && <h2 className={cn(TYPE.tt, "m-0 text-gray-900")}>{title}</h2>}
            <p className={cn(TYPE.tb, "m-0 mt-1 text-gray-600")}>{children}</p>
        </div>
    );
}
